import { Component, h, Host, Element, Prop } from "@stencil/core";
import { modalName } from "./modal-name";

@Component({
    tag: "ux-iws-nb-contact-modal",
    styleUrl: "nb-contact-modal.scss",
    shadow: false,
})
export class NbContactModal {
    @Element() host: HTMLUxIwsNbContactModalElement;
    /** Name of the modal (is used to open the modal) - default: "ux-iws-nb-contact-modal" */
    @Prop() modalName: string = modalName;
    /** if the modal should be opened on load */
    @Prop() opened: boolean = false;

    render() {
        return (
            <Host>
                <ux-modal
                    closeOnBackdropClick
                    name={this.modalName}
                    opened={this.opened}
                >
                    <ux-modal-content>
                        <h2>Kontakt</h2>
                        <ux-tab-container>
                            <ux-tab
                                name="Kontakt aufnehmen"
                                tab-id="contact-form"
                            >
                                <p>This is "Kontakt aufnehmen" content</p>
                            </ux-tab>
                            <ux-tab name="Kontaktdaten" tab-id="contact-data">
                                <p>This is "Kontaktdaten" tab content</p>
                            </ux-tab>
                        </ux-tab-container>
                    </ux-modal-content>
                </ux-modal>
            </Host>
        );
    }
}
